const DEFAULT_SIDES = ['front', 'back', 'sleeve', 'hood']

const isValidDimensionValue = (value) => {
    return value !== null && value !== undefined && value !== ''
}

const isValidDimension = (values) => {
    return isValidDimensionValue(values?.width) && isValidDimensionValue(values?.height)
}

export const getSideFromVariants = (variants = []) => {
    const sides = new Set()

    for (const variant of variants) {
        if (!Array.isArray(variant?.dimensions)) continue

        for (const dimension of variant.dimensions) {
            for (const [side, values] of Object.entries(dimension)) {
                if (isValidDimension(values)) {
                    sides.add(side)
                }
            }
        }
    }

    return sides.size > 0 ? Array.from(sides) : DEFAULT_SIDES
}